<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Leave Balance</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#!"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">
            <a href="#!" class="breadcrumb-button">Leave Balance</a>
          </li> -->
          <li class="breadcrumb-item active" aria-current="page">Leave Balance</li>
        </ol>
      </nav>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3>Leave Balance</h3>
      <div *ngIf="isBusinessOwner" class="d-flex align-items-center">
        <!-- <div class="dropdown me-3">
          <select
            class="form-select"
            id="selectedBusiness"
            [(ngModel)]="selectedBusiness"
            (ngModelChange)="onFilterChange(true)"
          >
            <option *ngFor="let business of user?.businesses" [value]="business.id">
              {{ business.businessName }}
            </option>
          </select>
        </div> -->
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
              {{ limit }}
            </option>
          </select>
        </div>
        <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="selectedBusiness"
          (change)="onFilterChange()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>
        <div class="dropdown me-3">
          <select
            class="form-select"
            id="isEmployeeActive"
            [(ngModel)]="isEmployeeActive"
            (ngModelChange)="onFilterChange(true)"
          >
            <option [value]="true">Active</option>
            <option [value]="false">Inactive</option>
          </select>
        </div>
        <div class="dropdown me-3">
          <input
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="onFilterChange(true)"
            class="form-control"
            placeholder="Search Employees"
          />
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="custom-datatable-filter table-responsive">
          <ng-container *ngIf="assignedPolicyBalanceList.length > 0; else noRecords">
            <table class="table datatable" *ngIf="assignedPolicyBalanceList.length > 0">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Policy</th>
                  <th>Available Balance</th>
                  <th>Next Accrual Date</th>
                  <th>Next Accrual Balance</th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let assignment of assignedPolicyBalanceList"
                  [class.disabled-row]="assignment.disabled"
                >
                  <ng-container *ngIf="assignment.user">
                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                          class="avatar avatar-md"
                          data-bs-toggle="modal"
                          data-bs-target="#view_details"
                        >
                          <ng-container *ngIf="assignment.user.picture; else initials">
                            <img
                              [src]="apiEndpoint + '/uploads/' + assignment.user.picture"
                              class="rounded-circle border border-2"
                              alt="img"
                            />
                          </ng-container>

                          <ng-template #initials>
                            <span
                              class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                              style="width: 30px; height: 30px"
                              >{{
                                getInitials(assignment.user.firstName, assignment.user.lastName)
                              }}</span
                            >
                          </ng-template>
                        </a>
                        <div class="ms-2">
                          <p class="text-dark mb-0">
                            <a [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                              >{{ assignment.user.firstName | capitalize }}
                              {{ assignment.user.lastName | capitalize }}</a
                            >
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ assignment.leavePolicy.title }} <br />
                      <span class="fs-12">{{ assignment.leavePolicy.leaveType | capitalize }}</span>
                    </td>
                    <td>
                      {{
                        ![
                          leaveTypeEnum.MATERNITY,
                          leaveTypeEnum.PATERNITY,
                          leaveTypeEnum.SABBATICAL,
                          leaveTypeEnum.LEAVEWITHOUTPAY
                        ].includes(assignment.leavePolicy.leaveType)
                          ? assignment.availableBalance
                          : 0.0
                      }}
                    </td>
                    <td>
                      {{
                        ![
                          leaveTypeEnum.MATERNITY,
                          leaveTypeEnum.PATERNITY,
                          leaveTypeEnum.SABBATICAL,
                          leaveTypeEnum.LEAVEWITHOUTPAY,
                          leaveTypeEnum.COMPOFF
                        ].includes(assignment.leavePolicy.leaveType)
                          ? (assignment.nextAccrualDate | date: 'mediumDate')
                          : ''
                      }}
                    </td>
                    <td>
                      {{
                        ![
                          leaveTypeEnum.MATERNITY,
                          leaveTypeEnum.PATERNITY,
                          leaveTypeEnum.SABBATICAL,
                          leaveTypeEnum.LEAVEWITHOUTPAY,
                          leaveTypeEnum.COMPOFF
                        ].includes(assignment.leavePolicy.leaveType)
                          ? assignment.upcomingBalance
                          : 0.0
                      }}
                    </td>
                    <td class="text-end">
                      <div class="action-icon d-inline-flex">
                        <button
                          *appHasPermission="{ leaveBalance: ['edit'] }"
                          type="button"
                          class="btn btn-icon-style p-1 m-1"
                          (click)="openEditModal(editModal, assignment)"
                        >
                          <i class="ti ti-edit"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon-style p-1 m-1"
                          aria-label="View item"
                          data-bs-toggle="tooltip"
                          title="View"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasRightBalanceViewer"
                          aria-controls="offcanvasRightBalanceViewer"
                          (click)="
                            balanceViewerDrawer(
                              assignment.user.id,
                              assignment.leavePolicy.id,
                              assignment.id
                            )
                          "
                        >
                          <i class="ti ti-eye"></i>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </ng-container>
          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div>
        <!-- pagination -->

        <ng-container *ngIf="assignedPolicyBalanceList.length > 0">
          <div
            class="d-flex align-items-center justify-content-between ms-2"
            *ngIf="assignedPolicyBalanceList.length > 0"
          >
            <div>
              Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
              {{ totalCount }} entries
            </div>
            <div class="has-text-centered mt-3">
              <app-pagination
                [currentPage]="currentPage"
                [pageSize]="pageLimit"
                [totalRows]="totalCount"
                (pageChange)="onPageChange($event)"
              ></app-pagination>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- attendance policy offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasRightBalanceViewer"
  aria-labelledby="offcanvasRightLabel"
  (hidden.bs.offcanvas)="showNextAccrualDetails = false"
>
  <div class="offcanvas-header">
    <div>
      <h5 id="offcanvasRightLabel">Balance Accrual Timeline</h5>
      <span>{{ userAndPolicyName }}</span
      ><br />
      <span class="fs-12">{{ policyType }}</span>
    </div>

    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>

  <div class="offcanvas-body" style="min-width: 40%">
    <ng-container *ngIf="selectedBalances$ | async as balancesByYear; else noRecords">
      <ng-container *ngIf="!isDisabled(balancesByYear); else noRecords">
        <div *ngIf="(balancesByYear | keyvalue).length > 0; else noRecords">
          <div class="accordion" id="leaveYearAccordion">
            <div
              class="accordion-item"
              *ngFor="
                let item of balancesByYear | keyvalue: sortYearsDesc;
                let i = index;
                let isFirst = first;
                let isLast = last
              "
            >
              <h2 class="accordion-header" [id]="'heading' + i">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#collapse' + i"
                  [class.collapsed]="i !== 0"
                  [attr.aria-expanded]="i === 0"
                  [attr.aria-controls]="'collapse' + i"
                >
                  Year: {{ item.key }}
                </button>
              </h2>
              <div
                [id]="'collapse' + i"
                class="accordion-collapse collapse"
                [class.show]="i === 0"
                [attr.aria-labelledby]="'heading' + i"
                data-bs-parent="#leaveYearAccordion"
                (hidden.bs.collapse)="showNextAccrualDetails = false"
              >
                <div class="accordion-body">
                  <div *ngIf="isFirst" class="d-flex align-items-start">
                    <div class="col-xl-3 active-time">
                      <!--<p class="mb-0">{{ balance.createdAt | date: 'h:mm a' }}</p>
                    <p>{{ balance.createdAt | date: 'dd MMM yyyy' }}</p>-->
                    </div>
                    <div *ngIf="!showNextAccrualDetails" class="py-4 ps-4 ms-3">
                      <a href="javascript:void(0)" (click)="toggleAccrualDetails()"
                        >View Next Accrual Details</a
                      >
                    </div>
                    <div
                      *ngIf="showNextAccrualDetails"
                      class="flex-fill ps-3 pb-4 timeline-flow warning"
                    >
                      <span class="current-balance-label">{{
                        totalBalance(item.value[0].currentBalance, item.value[0].upcomingBalance)
                      }}</span>
                      <span class="label">{{ item.value[0].upcomingBalance }}</span>
                      <div class="bg-light p-2 rounded">
                        <div class="d-flex justify-content-between mb-1">
                          <span class="badge rounded-pill bg-soft-primary">Next Accrual</span>
                        </div>
                        <span>
                          <strong> Next Accrual Date: </strong>
                          &nbsp; {{ item.value[0].nextAccrualDate | date: 'dd MMM yyyy' }}, upcoming
                          balance:
                          {{ item.value[0].upcomingBalance }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngFor="let balance of getFilteredBalances(item.value)"
                    class="d-flex align-items-start"
                  >
                    <div class="col-xl-3 active-time">
                      <p class="mb-0">{{ balance.createdAt | date: 'h:mm a' }}</p>
                      <p>{{ balance.createdAt | date: 'dd MMM yyyy' }}</p>
                      <!-- <p>{{ balance.id }}</p> -->
                    </div>
                    <div
                      class="flex-fill ps-3 pb-4 timeline-flow"
                      [ngClass]="{
                        pending: balance?.appliedLeaves?.status === 'Pending',
                        error:
                          balance?.appliedLeaves?.status === 'Rejected' ||
                          balance?.appliedLeaves?.status === 'Cancelled' ||
                          balance?.appliedLeaves?.status === 'Approved' ||
                          balance?.appliedLeaves?.status === 'Applied',
                        success:
                          balance?.appliedLeaves?.status !== 'Pending' &&
                          balance?.appliedLeaves?.status !== 'Rejected' &&
                          balance?.appliedLeaves?.status !== 'Cancelled' &&
                          balance?.appliedLeaves?.status !== 'Approved' &&
                          balance?.appliedLeaves?.status !== 'Applied'
                      }"
                    >
                      <span class="current-balance-label">{{ balance.currentBalance }}</span>
                      <span class="label">{{ balance.changeBalance }}</span>
                      <div class="bg-light p-2 rounded">
                        <div class="d-flex justify-content-between mb-1">
                          <ng-container *ngIf="balance.appliedLeaves; else accrual">
                            <div>
                              <span class="badge rounded-pill bg-soft-danger me-2">Request</span>
                              <span class="badge rounded-pill bg-soft-dark">{{
                                balance.appliedLeaves.status === 'Approved'
                                  ? 'Approved'
                                  : (balance.balanceChangeReason | capitalize)
                              }}</span>
                              <span *ngIf="balance.appliedLeaves"
                                ><a
                                  href="javascript:void(0)"
                                  class="ms-2"
                                  data-bs-toggle="modal"
                                  data-bs-target="#view_details"
                                  (click)="openOffcanvasLeave(balance)"
                                  placement="right"
                                >
                                  <i class="ti ti-info-circle text-info"></i> </a
                              ></span>
                            </div>
                          </ng-container>
                          <ng-template #accrual>
                            <span class="badge rounded-pill bg-soft-success">{{
                              balance.balanceChangeReason | capitalize
                            }}</span>
                          </ng-template>
                        </div>
                        <!-- <span>
                          <strong>
                            <ng-container *ngIf="balance.appliedLeaves; else accreuedBalance">
                              Request {{ balance.balanceChangeReason | capitalize }}:
                            </ng-container>
                            <ng-template #accreuedBalance
                              >{{ balance.balanceChangeReason | capitalize }} Balance:</ng-template
                            >
                          </strong>
                          &nbsp;{{ balance.changeBalance }} day(s) as on
                          {{ balance.createdAt | date: 'dd MMM yyyy' }}, making balance:
                          {{ balance.currentBalance }}</span
                        > -->
                        <span>
                          <strong>
                            <ng-container *ngIf="balance.appliedLeaves; else accreuedBalance">
                              Request {{ balance.balanceChangeReason | capitalize }}:
                            </ng-container>
                            <ng-template #accreuedBalance>
                              {{ balance.balanceChangeReason | capitalize }} Balance:
                            </ng-template>
                          </strong>

                          &nbsp;

                          <ng-container *ngIf="balance.appliedLeaves; else createdDate">
                            {{ balance.changeBalance }} day(s) for
                            {{ balance.appliedLeaves.fromDate | date: 'd MMMM yyyy' }}

                            <ng-container
                              *ngIf="
                                balance.appliedLeaves.toDate !== balance.appliedLeaves.fromDate
                              "
                            >
                              to
                              {{
                                balance.appliedLeaves.toDate | date: 'd MMMM yyyy'
                              }} </ng-container
                            >, making balance: {{ balance.currentBalance }}
                          </ng-container>

                          <ng-template #createdDate>
                            {{ balance.changeBalance }} day(s) as on
                            {{ balance.createdAt | date: 'dd MMM yyyy' }}, making balance:
                            {{ balance.currentBalance }}
                          </ng-template>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isLast" class="d-flex align-items-start">
                    <div class="col-xl-3 active-time">
                      <!--<p class="mb-0">{{ balance.createdAt | date: 'h:mm a' }}</p>
                    <p>{{ balance.createdAt | date: 'dd MMM yyyy' }}</p>
                    <p>{{ balance?.appliedLeaves?.status }}</p>-->
                    </div>
                    <div class="flex-fill ps-3 pb-4 timeline-flow success">
                      <span class="current-balance-label">0</span>
                      <!--<span class="label"></span>-->
                      <div>
                        <div class="d-flex justify-content-between mb-1">
                          <!--<ng-container *ngIf="balance.appliedLeaves; else accrual">
                          <div>
                            <span class="badge rounded-pill bg-soft-danger me-2">Request</span>
                            <span class="badge rounded-pill bg-soft-dark">{{
                              balance.balanceChangeReason
                            }}</span>
                          </div>
                        </ng-container>
                        <ng-template #accrual>
                          <span class="badge rounded-pill bg-soft-success">{{
                            balance.balanceChangeReason
                          }}</span>
                        </ng-template>-->
                        </div>
                        <!--<span>
                        <strong>
                          <ng-container *ngIf="balance.appliedLeaves; else accreuedBalance">
                            Request {{ balance.balanceChangeReason }}:
                          </ng-container>
                          <ng-template #accreuedBalance
                            >{{ balance.balanceChangeReason }} Balance:</ng-template
                          >
                        </strong>
                        &nbsp;{{ balance.changeBalance }} day(s) as on
                        {{ balance.createdAt | date: 'dd MMM yyyy' }}, making balance:
                        {{ balance.currentBalance }}</span
                      >-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- end offcanvas-->

<ng-template #loading>
  <!-- <p>Loading business details...</p> -->
  <app-loader></app-loader>
</ng-template>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Update Available Balance</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <!-- <i class="ti ti-id me-2"></i> -->
                Policy Name
              </span>

              <p>{{ editAssignment.leavePolicy.title }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <!-- <i class="ti ti-id me-2"></i> -->
                Employee Name
              </span>

              <p>{{ editAssignment.user.firstName }} {{ editAssignment.user.lastName }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <!-- <i class="ti ti-id me-2"></i> -->
                Existing Available Balance
              </span>

              <p>{{ editAssignment.availableBalance }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="balance" class="col-form-label"
                >New Available Balance <span class="text-danger">*</span></label
              >
              <input
                class="form-control"
                type="number"
                formControlName="balance"
                appTrimInput
                min="0"
              />

              <div *ngIf="form.get('balance')?.invalid && form.get('balance')?.touched">
                <span class="text-danger">{{ getErrorMessage('balance') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="reason" class="col-form-label">Reason </label>
              <textarea
                class="form-control"
                type="text"
                formControlName="reason"
                appTrimInput
              ></textarea>

              <div *ngIf="form.get('reason')?.invalid && form.get('reason')?.touched">
                <span class="text-danger">{{ getErrorMessage('reason') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onUpdateBalance()"
        [disabled]="form.invalid"
      >
        Update
      </button>
    </div>
  </form>
</ng-template>

<!-- leave details -->
<div
  class="modal fade"
  id="view_details"
  tabindex="-1"
  aria-labelledby="viewDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewDetailsLabel">Request Details</h5>
        <button
          type="button"
          class="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedLeave">
        <p>
          <strong>Name:</strong> {{ selectedLeave.user?.firstName }}
          {{ selectedLeave.user?.lastName }}
        </p>
        <!-- <p>
          <strong>Applied By:</strong> {{ selectedLeave.appliedLeaves?.appliedByUser?.firstName }}
          {{ selectedLeave.appliedLeaves?.appliedByUser?.lastName }}
        </p> -->
        <p><strong>Leave Type:</strong> {{ selectedLeave.appliedLeaves?.leaveType }}</p>
        <p>
          <strong>Date Range:</strong>
          {{ selectedLeave.appliedLeaves.fromDate | date: 'mediumDate' }} -
          {{ selectedLeave.appliedLeaves.toDate | date: 'mediumDate' }}
        </p>
        <p><strong>No. of Days:</strong> {{ selectedLeave.appliedLeaves.leaveDays }}</p>
        <p><strong>Status:</strong> {{ selectedLeave.appliedLeaves.status }}</p>
        <!-- <p>
          <strong>Approver:</strong> {{ selectedLeave.approver?.firstName }}
          {{ selectedLeave.approver?.lastName }}
        </p> -->
        <p><strong>Reason:</strong> {{ selectedLeave.appliedLeaves.reason }}</p>

        <div *ngIf="parsedDateRange.length > 0">
          <hr />
          <h6 class="mt-2">Requested Dates:</h6>
          <ul class="list-group">
            <li
              *ngFor="let day of parsedDateRange; let i = index"
              class="list-group-item d-flex justify-content-between"
            >
              <span>
                <strong>Date:</strong> {{ day.date | date: 'dd MMMM yyyy' }}<br />
                <strong>For:</strong> {{ day.selectionType }}
                {{ day.halfDayOption ? ' - ' + day.halfDayOption : '' }}
              </span>
            </li>
          </ul>
        </div>
        <!-- Add more fields as needed -->
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div> -->
    </div>
  </div>
</div>

<!-- end leave details -->
